import { All, Man, Woman } from '@/components/icon';
import { VoiceAge, VoiceGender } from '@/interface/aigc';

const VOICE_TABS = [
  {
    label: '全部',
    icon: <All />,
    value: VoiceGender.ALL,
  },
  {
    label: '男声',
    icon: <Man />,
    value: VoiceGender.MAN,
  },
  {
    label: '女声',
    icon: <Woman />,
    value: VoiceGender.WOMAN,
  },
  // {
  //   label: '我的',
  //   icon: <Human />,
  //   value: VoiceType.MINE,
  // },
];

const GENDER_OPTIONS = [
  { label: '女', value: VoiceGender.WOMAN },
  { label: '男', value: VoiceGender.MAN },
  { label: '其他', value: VoiceGender.OTHER },
];

const AGE_OPTIONS = [
  { label: '儿童', value: VoiceAge.CHILD },
  { label: '青年', value: VoiceAge.TEENAGER },
  { label: '老年', value: VoiceAge.OLD },
  { label: '其他', value: VoiceAge.OTHER },
];

export { AGE_OPTIONS, GENDER_OPTIONS, VOICE_TABS };
